import { Box, Grid } from "@mui/material";
import { translate } from "locale/formatter";
import { colors, fonts } from "styles/AtomicStyles";
import { formatDecimalNumber } from "utils";
import { currency } from "utils/currencyFormatter";

import { ImageIcons } from "components";
import Text from "components/Text";

import { classes } from "./styled";

export const formatAmount = (amount) => {
  if (!amount) return { display: '0', full: '0.00' };
  
  const num = parseFloat(amount);
  if (num >= 10000000) {
    return {
      display: `${(num / 10000000).toFixed(2)}Cr`,
      full: num.toLocaleString('en-IN', { maximumFractionDigits: 2 })
    };
  }
  if (num >= 100000) {
    return {
      display: `${(num / 100000).toFixed(2)}L`,
      full: num.toLocaleString('en-IN', { maximumFractionDigits: 2 })
    };
  }
  if (num >= 1000) {
    return {
      display: `${(num / 1000).toFixed(2)}K`,
      full: num.toLocaleString('en-IN', { maximumFractionDigits: 2 })
    };
  }
  return {
    display: num.toLocaleString('en-IN', { maximumFractionDigits: 2 }),
    full: num.toLocaleString('en-IN', { maximumFractionDigits: 2 })
  };
};

const OutstandingCard = ({ customerDetails, outstanding }) => {
  const {
    outstandingContainer,
    fontSize11,
    detailsClass,
    flexClass,
    outstandingText,
    logoContainer,
    outstandingTextColor,
    fontSize28,
    detailsFruitX,
  } = classes();

  const { totalOutstanding } = (customerDetails || []).reduce(
    (totals, acc) => {
      totals.totalOutstanding += +acc.outstanding_amount || 0;
      return totals;
    },
    { totalOutstanding: 0 }
  );

  const amount = outstanding || totalOutstanding || 0;
  const { display } = formatAmount(amount);

  return (
    <Box className={outstandingContainer}>
      <Grid container>
        <Grid container className={flexClass}>
          <Grid item md={12} xs={12} className={outstandingText}>
            <Text
              className={`${fontSize11} ${outstandingTextColor}`}
              style={{ fontFamily: fonts.NOTO_SANS }}
            >
              {translate("total_outstanding")} 
            </Text>
          </Grid>
        </Grid>
        <Grid container className={detailsFruitX}>
          <Grid item md={6} xs={6} className={detailsClass}>
            <Text className={fontSize28}>
              <span className="!text-2xl relative -top-4">
                {translate("INR")} 
              </span>
              <span className="!text-5xl !font-bold">
                {display}
              </span>
            </Text>
          </Grid>
          <Grid item md={6} xs={6} className={logoContainer}>
            <ImageIcons name="Logo" alt="fruitX-logo" />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OutstandingCard;